import { AppBar, CloseOutlinedIcon, Flex, IconButton, Text } from '@shared/components';

export interface QuestionPreviewModalHeaderProps {
  onBack: () => void;
}

export default function QuestionPreviewModalHeader(
  props: Readonly<QuestionPreviewModalHeaderProps>,
) {
  const { onBack } = props;

  return (
    <AppBar
      position='sticky'
      sx={(theme) => ({
        bgcolor: theme.palette.grey[900],
        color: theme.palette.common.white,
      })}
    >
      <Flex
        sx={(theme) => ({
          p: theme.spacing(4, 6),
          alignItems: 'center',
          justifyContent: 'flex-start',
        })}
      >
        <Text
          variant='h5'
          sx={{
            m: 'auto',
          }}
        >
          Preview Question
        </Text>
        <IconButton color='inherit' onClick={onBack} aria-label='close'>
          <CloseOutlinedIcon sx={{ fontSize: '24px' }} />
        </IconButton>
      </Flex>
    </AppBar>
  );
}
